
import React, { useEffect } from "react";
import Outlook from './Outlook.jsx';
import Overview from './Overview.jsx';
import NotFoundPage from './NotFoundPage.jsx';
import { useLocation, useParams } from 'react-router-dom';
import { useAppData } from '../context/AppDataContext.jsx';
import { trackEvent } from '../services/appInsights';

const getRouteType = (pathname) => {
    if (pathname.includes('overview')) return 'overview';
    if (pathname.includes('outlook')) return 'outlook';
    return null;
};

const defaultOptions = {
	title: 'Title',
	description: 'Description',
	icon: 'ℹ️',
	subTitle: 'Energy Dataset Overview',
	details: `<p>
		This comprehensive global dataset provides detailed insights into worldwide energy markets, 
		including historical data, current market conditions, and forward-looking projections. 
		Our analysis covers:
	</p>
	<ul>
		<li>Global supply and demand fundamentals</li>
		<li>Regional market dynamics and price differentials</li>
		<li>Trade flow patterns and logistics constraints</li>
		<li>Refining capacity and utilization trends</li>
		<li>Policy impacts and regulatory developments</li>
		<li>Technology adoption and energy transition indicators</li>
	</ul>`,
	cardsTitle: 'Data Categories',
	cards: [
	{ icon: '🛢️', name: 'Supply & Demand Analysis', description: 'Global production and consumption trends' },
	{ icon: '📈', name: 'Price Forecasting', description: 'Market pricing models and projections' },
	{ icon: '🚢', name: 'Trade Flow Analysis', description: 'International trade patterns and logistics' },
	{ icon: '🏭', name: 'Infrastructure Mapping', description: 'Facility capacity and utilization data' },
],
	selectorTitle : "Selector title", 
	overviewUrl : "",
    outlookUrl : "",
    publicationsOutlook : "", 
    defaultFilters: [],
    hasPermission : true // TODO: Will eventually be calculated from the database
};


const OutlookWrapper = () => {
    const location = useLocation();
    const params = useParams();
    const { me, outlooks, loading, error, config } = useAppData();
    const routeType = getRouteType(location.pathname);

    // Wait for context to load
    if (loading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div style={{ color: 'red' }}>Error: {error.message || error.toString()}</div>;
    }

    // Overview route logic unchanged
    const isOverview = routeType === 'overview';


    // Extract outlookId from params
    const { outlookId } = params;

    const outlook = outlooks.find(o => o.id === outlookId);

    useEffect(() => {
        if (outlook) {
            trackEvent('OutlookPageVisit', {
                outlookId,
                outlookTitle: outlook.title,
                routeType,
                allowed: String(Array.isArray(me?.outlooks) && me.outlooks.some(o => o.key === outlookId)),
            });
        }
    }, [outlookId, routeType]);

    let allowed = false;

    if (outlook) {
        if (Array.isArray(me?.outlooks)) {
            const userOutlook = me.outlooks.find(o => o.key === outlookId);
            if (userOutlook) {
                allowed = true;
            }
        }
    }

    if (isOverview) {
        return <Overview {...outlook} outlookId={outlookId} me={me} config={config} allowed={allowed} />;
    }

    if (outlook && allowed) {
        // Pass outlookId, outlook, and me to Outlook
        return <Outlook outlook={outlook} outlookId={outlookId} me={me} config={config} />;
    }

    if (outlook) {
        return <Overview {...outlook} outlookId={outlookId} me={me} config={config} allowed={allowed} />;
    }

    // If no outlook or not allowed, show 404
    return <NotFoundPage />;
};

export default OutlookWrapper;